//Enable for Eid
import useSessionstorage from "@rooks/use-sessionstorage";
import { Disclosure } from '@headlessui/react';
import { useState } from 'react';
import Link from 'next/link';
import Head from "next/head";

//internal import
import Layout from "@layout/Layout";
import Banner from "@component/banner/Banner";
import Card from "@component/cta-card/Card";
import CardTwo from "@component/cta-card/CardTwo";
// import OfferCard from "@component/offer/OfferCard";
import StickyCart from "@component/cart/StickyCart";
import ProductServices from "@services/ProductServices";
import ProductCard from "@component/product/ProductCard";
import MainCarousel from "@component/carousel/MainCarousel";
import FeatureCategory from "@component/category/FeatureCategory";
import BlogCarousel from "@component/blog/BlogCarousel";
import { GhostContentServices } from "@services/GhostContentServices";
import { SiteLinksSearchBoxJsonLd } from 'next-seo';
import Holiday from "@component/notice/holiday";
// import PrayerTimes from "@component/notice/prayertimes";
import EidMubarak from "@component/notice/EidMubarak";
import { useFeatureFlagEnabled } from 'posthog-js/react'


const Home = ({ bestSellingProduct, latestProducts, discountProducts, relatedProduct, blogPosts }) => {
  const flagEnabledEid = useFeatureFlagEnabled('eid-sale')
  const flagEnabledHoliday = useFeatureFlagEnabled('holiday-schedule')

  return <>
    <Layout>
      <SiteLinksSearchBoxJsonLd
        url="https://www.cubenationshop.com"
        potentialActions={[
          {
            target: 'https://www.cubenationshop.com/search?query',
            queryInput: 'search_term_string',
          },
        ]}
      />

      <Head>
        <link rel="search" type="application/opensearchdescription+xml" href="/opensearch.xml" title="CubeNation Search" />
        <meta property="og:title" content="Cube Nation - Bangladesh's Speed Cube collection & Twisty Puzzle Bazaar" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.cubenationshop.com/" />
        <meta property="og:image" content="/facebook-page.png" />
        <meta
          property="og:description"
          content="CubeNation is one of the largest Speed cube shops in Bangladesh (BD). It's simply a Puzzle Bazaar & cube collection store!"
        />
        <meta
          name="description"
          content="CubeNation is one of the largest Speed cube shops in Bangladesh (BD). It's simply a Puzzle Bazaar & cube collection store!" />
      </Head>
      <div className="min-h-screen">
        {flagEnabledEid && (
          <EidMubarak />
        )}
        {flagEnabledHoliday && (
          <Holiday />
        )}

        {//<PrayerTimes />
        }

        <StickyCart />

        <div className="bg-gradient-to-b from-gray-100 to-gray-50">
          <div className="mx-auto py-5 max-w-screen-2xl px-3 sm:px-10">
            <div className="flex w-full space-x-1">
              {//Enable on Eid
                <div className="flex-shrink-0 xl:pr-6 lg:block w-full ">
                  <MainCarousel />
                </div>
              }
              {//disable on eid
                //<div className="flex-shrink-0 xl:pr-6 lg:block w-full lg:w-3/5">
                //<MainCarousel />
                //</div>
                //<div className="w-full lg:flex">
                // <OfferCard />
                //  </div>
              }

            </div>
            <div className="bg-gradient-to-b from-gray-100 to-red-50 px-10 py-6 rounded-lg mt-6  text-center  lg:block">
              <Banner />
            </div>
          </div>
        </div>

        {/* feature CTAs's */}
        <div className="bg-gray-100 lg:py-16 py-10 bg-gradient-to-b from-red-100 to-yellow-50">
          <div className="mx-auto max-w-screen-2xl px-3 sm:px-10">
            <div className="mb-10 flex justify-center">
              <div className="text-center w-full lg:w-2/5">
                <h2 className="text-xl lg:text-2xl mb-2 font-serif font-semibold">
                  CubeNation Recommends
                </h2>
                <p className="text-base font-sans text-gray-600 leading-6">
                  The value for money, picked by our speedcubers' team
                </p>
              </div>
            </div>
            <div className="w-full grid grid-col gap-4 grid-cols-1 2xl:gap-6 xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2">
              <Card />
            </div>
          </div>
        </div>

        {/* feature CTAs's */}
        <div className="bg-white-100 lg:py-16 py-10 bg-gradient-to-b from-yellow-100 to-blue-50">

          <div className="mx-auto max-w-screen-2xl px-3 sm:px-10">
            <div className="mb-10 flex justify-center">
              <div className="text-center w-full ">
                <h2 className="text-xl lg:text-2xl mb-2 font-serif font-semibold">
                  Cubicle Lubes
                </h2>
                <p className="text-base font-sans text-gray-600 leading-6">
                  World's best for speedcubes
                </p>
              </div>
            </div>
            <div className="w-full grid grid-col gap-4 grid-cols-2 2xl:grid-cols-6 xl:grid-cols-6 lg:grid-cols-4 md:grid-cols-3">
              {relatedProduct?.filter(product => product.quantity > 0).slice(0, 6).map((product) => (
                <ProductCard key={product._id} product={product} />
              ))}


            </div>

          </div>


          <div className="mt-7 flex justify-center">
            <div className="text-center w-full lg:w-2/5">


              <Link
                href="/relatedProduct/Cubicle"
                className="inline-block text-center lg:w-2/5 bg-yellow-300 hover:bg-red-400 hover:text-red-900 text-yellow-800 font-bold py-3 px-6 rounded-md transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110">

                View all

              </Link>

            </div>
          </div>

        </div>







        {/* feature category's */}
        <div className="lg:py-16 py-10 bg-gradient-to-b from-blue-100 to-orange-50">
          <div className="mx-auto max-w-screen-2xl px-3 sm:px-10">
            <div className="mb-10 flex justify-center">
              <div className="text-center w-full lg:w-2/5">
                <h2 className="text-xl lg:text-2xl mb-2 font-serif font-semibold">
                  Popular Categories
                </h2>
                <p className="text-base font-sans text-gray-600 leading-6">
                  All the types of Puzzle & Speedcube we sell.
                </p>
              </div>
            </div>
            <FeatureCategory />
          </div>
        </div>

        {/* newly added products */}
        <div className="bg-gray-50 lg:py-16 py-10  px-3 sm:px-10 bg-gradient-to-b from-orange-100 to-green-50">
          <div className="mb-10 flex mx-auto max-w-screen-2xl justify-center">
            <div className="text-center w-full lg:w-2/5">
              <h2 className="text-xl lg:text-2xl mb-2 font-serif font-semibold">
                Newest releases
              </h2>
              <p className="text-base font-sans text-gray-600 leading-6">
                New puzzles to enrich your collection!
              </p>
            </div>
          </div>
          <div className="flex justify-center">
            <div className="max-w-screen-2xl">
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 xl:grid-cols-5 2xl:grid-cols-6 gap-2 md:gap-3 lg:gap-3">
                {latestProducts?.slice(0, 12).map((product) => (
                  <ProductCard key={product._id} product={product} />
                ))}
              </div>
            </div>
          </div>
          <div className="mt-7 flex justify-center">
            <div className="text-center w-full lg:w-2/5">


              <Link
                href="/new"
                className="inline-block text-center lg:w-2/5 bg-orange-300 hover:bg-red-400 hover:text-red-900 text-orange-800 font-bold py-3 px-6 rounded-md transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110">

                View all

              </Link>

            </div>
          </div>
        </div>

        {/* best selling products */}
        <div className="bg-gray-50 lg:py-16 py-10  px-3 sm:px-10 bg-gradient-to-b from-green-100 to-red-50">
          <div className="mb-10 flex mx-auto max-w-screen-2xl justify-center">
            <div className="text-center w-full lg:w-2/5">
              <h2 className="text-xl lg:text-2xl mb-2 font-serif font-semibold">
                Bestselling Puzzles
              </h2>
              <p className="text-base font-sans text-gray-600 leading-6">
                Top choices of speedcubers and puzzle-lovers in Bangladesh.
              </p>
            </div>
          </div>
          <div className="flex justify-center">
            <div className="max-w-screen-2xl">
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 xl:grid-cols-5 2xl:grid-cols-6 gap-2 md:gap-3 lg:gap-3">
                {bestSellingProduct?.slice(0, 6).map((product) => (
                  <ProductCard key={product._id} product={product} />
                ))}
              </div>
            </div>
          </div>
          <div className="mt-7 flex justify-center">
            <div className="text-center w-full lg:w-2/5">


              <Link
                href="/bestseller"
                className="inline-block text-center lg:w-2/5 bg-green-300 hover:bg-red-400 hover:text-red-900 text-green-800 font-bold py-3 px-6 rounded-md transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110">

                View all

              </Link>

            </div>
          </div>
        </div>        {/* promotional banner card */}
        <div className="block mx-auto bg-gradient-to-b from-red-100 to-yellow-50 ">
          <div className="mx-auto max-w-screen-2xl px-4 sm:px-10">
            <div className="lg:p-16 p-6  shadow-sm  rounded-lg">
              <CardTwo />
            </div>
          </div>
        </div>        {/* blog section */}
        {blogPosts && blogPosts.length > 0 && (
          <div className="bg-gray-50 lg:py-16 py-10 px-3 sm:px-10 bg-gradient-to-b from-yellow-100 to-indigo-50 overflow-hidden">
            <div className="mb-10 flex mx-auto max-w-screen-2xl justify-center">
              <div className="text-center w-full lg:w-2/5">
                <h2 className="text-xl lg:text-2xl mb-2 font-serif font-semibold">
                  Speed Cubing Tips & Guides
                </h2>
                <p className="text-base font-sans text-gray-600 leading-6">
                  Learn from the experts and improve your cubing skills
                </p>
              </div>
            </div>            <div className="mx-auto max-w-screen-2xl">
              <BlogCarousel posts={blogPosts} />
            </div>
            <div className="mt-8 flex justify-center">
              <Link
                href="/blog"
                className="inline-block text-center bg-indigo-300 hover:bg-red-400 hover:text-red-900 text-indigo-800 font-bold py-3 px-6 rounded-md transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110"
              >
                Read All Articles
              </Link>
            </div>
          </div>
        )}

        {/* discounted products */}
        <div
          id="discount"
          className="bg-gray-50 lg:py-16 py-10  px-3 sm:px-10 bg-gradient-to-b from-yellow-100 to-green-50"
        >
          <div className="mb-10 flex mx-auto max-w-screen-2xl justify-center">
            <div className="text-center w-full lg:w-2/5">
              <h2 className="text-xl lg:text-2xl mb-2 font-serif font-semibold">
                Puzzles on Sale
              </h2>
              <p className="text-base font-sans text-gray-600 leading-6">
                Choose your puzzle from here and avail discounts!
              </p>
            </div>
          </div>
          <div className="flex justify-center">
            <div className="max-w-screen-2xl">
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 xl:grid-cols-5 2xl:grid-cols-6 gap-2 md:gap-3 lg:gap-3">
                {discountProducts?.slice(0, 18).map((product) => (
                  <ProductCard key={product._id} product={product} />
                ))}
              </div>
            </div>
          </div>
          <div className="mt-7 flex justify-center">
            <div className="text-center w-full lg:w-2/5">


              <Link
                href="/offer"
                className="inline-block text-center lg:w-2/5 bg-yellow-300 hover:bg-red-400 hover:text-red-900 text-yellow-800 font-bold py-3 px-6 rounded-md transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110">

                View all

              </Link>

            </div>
          </div>
        </div>
      </div>
    </Layout>
    <div></div>
  </>;
};

export const getStaticProps = async () => {
  // Fetch data at build time and revalidate periodically
  try {
    const [bestSellingProduct, latestProducts, discountProducts, relatedProduct, blogPostsResult] =
      await Promise.all([
        ProductServices.getBestSellProducts(),
        ProductServices.getLatestProducts(),
        ProductServices.getDiscountedProducts(),
        ProductServices.searchProductBytags(["Cubicle"]), // Ensure this service works at build time
        // Fetch latest blog posts for homepage carousel
        GhostContentServices.getPosts(1, 6, 'tags,authors'),
      ]);

    return {
      props: {
        bestSellingProduct,
        latestProducts,
        discountProducts: discountProducts,
        relatedProduct,
        blogPosts: blogPostsResult.success ? blogPostsResult.posts : []
      },
      // Enable ISR: Re-generate the page in the background,
      // when a request comes in at most once every 3600 seconds (1 hour)
      revalidate: 3600,
    };
  } catch (error) {
    console.error('Error in getStaticProps:', error);
    return {
      props: {
        bestSellingProduct: [],
        latestProducts: [],
        discountProducts: [],
        relatedProduct: [],
        blogPosts: []
      },
      revalidate: 3600,
    };
  }
};

export default Home;
